/**
 * Store admin — storefront appearance composer, scoped to one appearance
 * (spec 42 story 4, spec 50 R1/R5).
 *
 * Net-new screen: `prototype/` has no `store/` deck, so the baseline is
 * `docs/spec/43-store-front-home-composer-design.md` AD1/AD2.
 */
import { createFileRoute } from "@tanstack/react-router";
import { StorefrontComposerPage } from "../../../../../../features/store/storefront/storefront-composer-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/storefront/$appearanceId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { appearanceId } = Route.useParams();
  return <StorefrontComposerPage appearanceId={appearanceId} />;
}
